module.exports = __webpack_public_path__ + "static/media/radiomars-news.c72d1d02.mp3";